/**
 * Verzija i datum deploy-a.
 * Preferira se /build-info.json sa servera (deploy ga piše pri svakom deploy-u, bez keša).
 * Fallback: window.__APP_BUILD__ iz index.html, pa process.env.
 */
export function getBuildInfo() {
  if (typeof window !== 'undefined' && window.__APP_BUILD__) {
    return {
      version: window.__APP_BUILD__.version || '?',
      deployDate: window.__APP_BUILD__.deployDate || null,
    };
  }
  return {
    version: typeof process !== 'undefined' && process.env?.REACT_APP_VERSION ? process.env.REACT_APP_VERSION : '?',
    deployDate: typeof process !== 'undefined' && process.env?.REACT_APP_DEPLOY_DATE ? process.env.REACT_APP_DEPLOY_DATE : null,
  };
}

/** Uvek učitaj verziju sa servera (GET /build-info.json, no-cache). Koristi u Postavkama. */
export async function fetchBuildInfoFromServer() {
  try {
    const r = await fetch('/build-info.json', { cache: 'no-store', headers: { 'Cache-Control': 'no-cache' } });
    if (r.ok) {
      const d = await r.json();
      return { version: d.version || '?', deployDate: d.deployDate || null };
    }
  } catch (_) {}
  return getBuildInfo();
}
